export default __webpack_public_path__ + "static/media/hvacImg2.7737de27.png";